import { render, staticRenderFns } from "./Menubar.vue?vue&type=template&id=103ec4dc&scoped=true"
import script from "./Menubar.vue?vue&type=script&lang=js"
export * from "./Menubar.vue?vue&type=script&lang=js"
import style0 from "./Menubar.vue?vue&type=style&index=0&id=103ec4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103ec4dc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme1Submenu: require('/app/components/Theme1/Submenu.vue').default})
